var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "viewBox": "0 0 200 200",
      "width": "200",
      "height": "200",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(-0.000000,-0.000000) scale(0.377358) translate(-0.000000,-0.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "group-18",
      "transform": "matrix(0.999305009841919, 0, 0, 0.999305009841919, 0.08954701572645263, 0.058169007301330566)"
    }
  }, [_c('circle', {
    staticStyle: {
      "fill": "rgb(50, 55, 59)"
    },
    attrs: {
      "cx": "254",
      "cy": "254",
      "r": "254"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "rgb(38, 44, 48)"
    },
    attrs: {
      "d": "M34.8,382c44,75.2,125.6,126,219.2,126s175.2-50.4,219.2-126H34.8z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#2b3b4e"
    },
    attrs: {
      "d": "M335.6,315.6v27.2h-44v-9.2c0-3.2-2.4-5.6-5.6-5.6h-69.6c-3.2,0-5.6,2.4-5.6,5.6v9.2h-56.4 c-3.6-13.2-15.6-22.8-30-22.8s-26.4,9.6-30,22.8H67.2v-27.2H335.6z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#324a5e"
    },
    attrs: {
      "d": "M335.6,315.6H67.2c-7.6,0-14-6.4-14-14V164c0-7.6,6.4-14,14-14h254.4c7.6,0,14,6.4,14,14L335.6,315.6 L335.6,315.6z"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#ff7058"
    },
    attrs: {
      "x": "53.2",
      "y": "203.6",
      "width": "282.4",
      "height": "50"
    }
  }), _c('polygon', {
    staticStyle: {
      "fill": "#84dbff"
    },
    attrs: {
      "points": "335.6,205.2 335.6,349.6 454.8,349.6 454.8,282.8 412.4,205.2 "
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M454.8,282.8v56h-21.6v10.8h-22c-0.8-16.4-14.4-29.6-31.2-29.6c-16.4,0-30,13.2-31.2,29.6h-13.6v-144 H412L454.8,282.8z"
    }
  }), _c('polygon', {
    staticStyle: {
      "fill": "#84dbff"
    },
    attrs: {
      "points": "440.4,275.6 407.2,214.4 344.8,214.4 344.8,275.6 "
    }
  }), _c('polygon', {
    staticStyle: {
      "fill": "#54c0eb"
    },
    attrs: {
      "points": "385.6,275.6 440.4,275.6 407.2,214.4 402.8,214.4 "
    }
  }), _c('circle', {
    staticStyle: {
      "fill": "#324a5e"
    },
    attrs: {
      "cx": "124.4",
      "cy": "351.2",
      "r": "31.2"
    }
  }), _c('g', [_c('circle', {
    staticStyle: {
      "fill": "#e6e9ee"
    },
    attrs: {
      "cx": "124.4",
      "cy": "351.2",
      "r": "20"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#e6e9ee"
    },
    attrs: {
      "d": "M286,356.4h-69.2c-3.2,0-5.6-2.4-5.6-5.6v-17.6c0-3.2,2.4-5.6,5.6-5.6H286c3.2,0,5.6,2.4,5.6,5.6 v17.6C291.6,354,289.2,356.4,286,356.4z"
    }
  })]), _c('rect', {
    staticStyle: {
      "fill": "#ff7058"
    },
    attrs: {
      "x": "443.2",
      "y": "310.8",
      "width": "11.6",
      "height": "23.2"
    }
  }), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M86.8,243.2c-1.2,0-2.4-1.2-2.4-2.4v-23.6c0-1.2,1.2-2.4,2.4-2.4h6.8c0,0,12,0,12,14 c0,14.4-12,14-12,14h-6.8V243.2z M89.2,238.4h4.4c0,0,2,0,3.6-1.2c2.4-1.6,3.6-4.4,3.6-8.4s-1.2-6.8-3.6-8.4 c-1.6-1.2-3.6-1.2-3.6-1.2h-4.4V238.4z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M134.8,240.8c0,1.2-1.2,2.4-2.4,2.4h-12.8c-1.2,0-2.4-1.2-2.4-2.4v-23.6c0-1.2,1.2-2.4,2.4-2.4h12.8 c1.2,0,2.4,1.2,2.4,2.4s-1.2,2.4-2.4,2.4H122v7.2h8c1.2,0,2.4,1.2,2.4,2.4s-1.2,2.4-2.4,2.4h-8v7.2h10.8 C134,238.4,134.8,239.2,134.8,240.8z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M148.8,243.2c-1.2,0-2.4-1.2-2.4-2.4v-23.6c0-1.2,1.2-2.4,2.4-2.4s2.4,1.2,2.4,2.4v21.2h8.4 c1.2,0,2.4,1.2,2.4,2.4s-1.2,2.4-2.4,2.4L148.8,243.2L148.8,243.2z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M172.8,240.8v-23.6c0-1.2,1.2-2.4,2.4-2.4s2.4,1.2,2.4,2.4v23.6c0,1.2-1.2,2.4-2.4,2.4 S172.8,242,172.8,240.8z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M198.8,241.6l-9.6-23.6c0-0.4-0.4-3.2,2-3.2c0.8,0,2,0.4,2,1.6l7.2,18l7.2-18c0.4-0.8,1.2-1.6,2-1.6 c2.8,0.4,2.4,2.8,2,3.2l-9.6,23.6c-0.4,0.8-1.2,1.6-2,1.6C200,243.2,199.2,242.4,198.8,241.6z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M241.6,240.8c0,1.2-1.2,2.4-2.4,2.4h-12.8c-1.2,0-2.4-1.2-2.4-2.4v-23.6c0-1.2,1.2-2.4,2.4-2.4h12.8 c1.2,0,2.4,1.2,2.4,2.4s-1.2,2.4-2.4,2.4h-10.8v7.2h8.4c1.2,0,2.4,1.2,2.4,2.4s-1.2,2.4-2.4,2.4h-8.4v7.2h10.8 C240.8,238.4,241.6,239.2,241.6,240.8z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M304,216.8c0,0.4,0,0.8-0.4,1.2l-8,11.2v11.2c0,1.2-1.2,2.4-2.4,2.4c-1.2,0-2.4-1.2-2.4-2.4v-11.2 l-8-11.2c-0.4-0.4-0.4-0.8-0.4-1.2c0-1.2,0.8-2.4,2.4-2.4c0.8,0,1.6,0.4,2,1.2l6.4,9.2l6.4-9.2c0.4-0.8,1.2-1.2,2-1.2 c0.4,0,0.8,0,1.2,0.4C303.6,215.6,304,216.4,304,216.8z"
    }
  })]), _c('path', {
    staticStyle: {
      "fill": "#e6e9ee"
    },
    attrs: {
      "d": "M364.8,286.8h-15.2c-2.8,0-5.2-2.4-5.2-5.2V280H370v2C370,284.8,367.6,286.8,364.8,286.8z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#324a5e"
    },
    attrs: {
      "d": "M455.2,338.8h-22v16h22c2,0,3.6-1.6,3.6-3.6v-8.4C458.8,340.4,457.2,338.8,455.2,338.8z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#2b3b4e"
    },
    attrs: {
      "d": "M415.6,349.6h-4.4c-0.8-16.4-14.4-29.6-31.2-29.6s-30.4,13.2-31.2,29.6h-4.4 c0.8-18.8,16.4-34,35.6-34S414.8,330.4,415.6,349.6z"
    }
  }), _c('circle', {
    staticStyle: {
      "fill": "#324a5e"
    },
    attrs: {
      "cx": "380",
      "cy": "351.2",
      "r": "31.2"
    }
  }), _c('circle', {
    staticStyle: {
      "fill": "#e6e9ee"
    },
    attrs: {
      "cx": "380",
      "cy": "351.2",
      "r": "20"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M266.4,232.4c2.8-1.6,4.8-4.8,4.8-8.4c0-5.2-4.4-9.6-9.6-9.6l0,0h-6.4c-1.2,0-2.4,1.2-2.4,2.4v23.6 c0,1.2,1.2,2.4,2.4,2.4c1.2,0,2.4-1.2,2.4-2.4v-7.2h3.6l5.2,8.4c0.8,1.2,2,1.6,3.2,0.8s1.6-2,0.8-3.2L266.4,232.4z M258,228.8v-9.2 h4c2.4,0,4.8,2,4.8,4.8c0,2.4-2,4.8-4.8,4.8h-4V228.8z"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }